<template>
    <form class="section-hom-form form-horizontal" @submit.prevent="handleSubmit">
        <!-- Card 1 -->
        <div class="panel panel-default">
            <div class="panel-heading ph1">
                <h3 class="panel-title">Card 1 - <span class="badge badge-alert">Posición {{ items[0].order + 1 }}</span></h3>
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Nombre link 1</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="nombre_link1" v-model="card1.nombreLink1">
                        <div class="help-block error-message" v-for="e in errors.card1.nombreLink1" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="active" class="col-sm-2 control-label">¿Link a ficha?</label>
                    <div class="col-sm-10">
                        <el-switch v-model="card1.showLink" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>
                <div  v-if="!card1.showLink" class="form-group">
                    <label for="link" class="col-sm-2 control-label">Link</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="link" v-model="card1.link">
                        <div class="help-block error-message" v-for="e in errors.card1.link" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div  v-if="card1.showLink" class="form-group">
                    <label for="tramite1" class="col-sm-2 control-label">Ficha</label>
                    <div class="col-sm-10">
                        <multiselect
                            placeholder="Buscar Ficha / tramite"
                            label="title"
                            track-by="master_id"
                            :options="options"
                            v-model="card1.selectedTramite1"
                        ></multiselect>
                        <div class="help-block error-message" v-for="e in errors.card1.selectedTramite1" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Posición</label>
                    <div class="col-sm-10">
                        <p class="help-block has-text-dark has-text-weight-bold">{{ items[0].order + 1 }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Card 2 -->
        <div class="panel panel-default">
            <div class="panel-heading ph2">
                <h3 class="panel-title">Card 2 - <span class="badge badge-alert">Posición {{ items[1].order + 1 }}</span></h3> 
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Nombre link 2</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="nombre_link1" v-model="card2.nombreLink1">
                        <div class="help-block error-message" v-for="e in errors.card2.nombreLink1" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="active" class="col-sm-2 control-label">¿Link a ficha?</label>
                    <div class="col-sm-10">
                        <el-switch v-model="card2.showLink" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>
                <div  v-if="!card2.showLink" class="form-group">
                    <label for="link" class="col-sm-2 control-label">Link</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="link" v-model="card2.link">
                        <div class="help-block error-message" v-for="e in errors.card2.link" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div  v-if="card2.showLink" class="form-group">
                    <label for="tramite1" class="col-sm-2 control-label">Ficha</label>
                    <div class="col-sm-10">
                        <multiselect
                            placeholder="Buscar Ficha / tramite"
                            label="title"
                            track-by="master_id"
                            :options="options"
                            v-model="card2.selectedTramite1"
                        ></multiselect>
                        <div class="help-block error-message" v-for="e in errors.card2.selectedTramite1" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Posición</label>
                    <div class="col-sm-10">
                        <p class="help-block has-text-dark has-text-weight-bold">{{ items[1].order + 1 }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Card 3 -->
        <div class="panel panel-default">
            <div class="panel-heading ph1">
                <h3 class="panel-title">Card 3 - <span class="badge badge-alert">Posición {{ items[2].order + 1 }}</span></h3>
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Nombre link 3</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="nombre_link1" v-model="card3.nombreLink1">
                        <div class="help-block error-message" v-for="e in errors.card3.nombreLink1" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="active" class="col-sm-2 control-label">¿Link a ficha?</label>
                    <div class="col-sm-10">
                        <el-switch v-model="card3.showLink" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>
                <div  v-if="!card3.showLink" class="form-group">
                    <label for="link" class="col-sm-2 control-label">Link</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="link" v-model="card3.link">
                        <div class="help-block error-message" v-for="e in errors.card3.link" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div  v-if="card3.showLink" class="form-group">
                    <label for="tramite1" class="col-sm-2 control-label">Ficha</label>
                    <div class="col-sm-10">
                        <multiselect
                            placeholder="Buscar Ficha / tramite"
                            label="title"
                            track-by="master_id"
                            :options="options"
                            v-model="card3.selectedTramite1"
                        ></multiselect>
                        <div class="help-block error-message" v-for="e in errors.card3.selectedTramite1" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Posición</label>
                    <div class="col-sm-10">
                        <p class="help-block has-text-dark has-text-weight-bold">{{ items[2].order + 1 }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Card 4 -->
        <div class="panel panel-default">
            <div class="panel-heading ph2">
                <h3 class="panel-title">Card 4 - <span class="badge badge-alert">Posición {{ items[3].order + 1 }}</span></h3>
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Nombre link 1</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="nombre_link1" v-model="card4.nombreLink1">
                        <div class="help-block error-message" v-for="e in errors.card4.nombreLink1" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="active" class="col-sm-2 control-label">¿Link a ficha?</label>
                    <div class="col-sm-10">
                        <el-switch v-model="card4.showLink" on-text="SI" off-text="NO"></el-switch>
                    </div>
                </div>
                <div v-if="!card4.showLink"class="form-group">
                    <label for="link" class="col-sm-2 control-label">Link</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="link" v-model="card4.link">
                        <div class="help-block error-message" v-for="e in errors.card4.link" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div v-if="card4.showLink" class="form-group">
                    <label for="tramite1" class="col-sm-2 control-label">Ficha</label>
                    <div class="col-sm-10">
                        <multiselect
                            placeholder="Buscar Ficha / tramite"
                            label="title"
                            track-by="master_id"
                            :options="options"
                            v-model="card4.selectedTramite1"
                        ></multiselect>
                        <div class="help-block error-message" v-for="e in errors.card4.selectedTramite1" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Posición</label>
                    <div class="col-sm-10">
                        <p class="help-block has-text-dark has-text-weight-bold">{{ items[3].order + 1 }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Order -->
        <div class="panel panel-default">
            <div class="panel-heading ph1">
                <h3 class="panel-title">Orden <span class="badge">Pevisualización drag and drop</span></h3>
            </div>
            <div class="panel-body body-grey">
                <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-5">
                        <h2 class="has-gob-title has-text-dark has-font-serif has-text-weight-bold">
                            Lo más buscado
                        </h2>
                        <draggable v-model="items" @start="drag=true" @end="drag=false" @change="onOrderChange" class="flex-container">
                            <div class="flex-item" v-for="item in items" :key="item.id">
                                <a :title="item.title" :href="item.link" class="card-object" target="_blank">
                                    <article class="card">
                                        <h5 class="has-text-primary has-font-serif is-underlined">
                                            {{ item.content }}
                                        </h5>
                                    </article>
                                </a>
                            </div>
                        </draggable>
                    </div>
                    <div class="col-md-4"></div>
                </div>
            </div>
        </div>


        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/sections-admin-page-contents/home">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>

<script>
import Multiselect from "vue-multiselect";
import draggable from 'vuedraggable';
export default {
    components: {
        Multiselect,
        draggable,
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        inputs: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            card1: {
                nombreLink1: '',
                showLink: false,
                link: '',
                selectedTramite1: null,
            },
            card2: {
                nombreLink1: '',
                showLink: false,
                link: '',
                selectedTramite1: null,
            },
            card3: {
                nombreLink1: '',
                showLink: false,
                link: '',
                selectedTramite1: null,
            },
            card4: {
                nombreLink1: '',
                showLink: false,
                link: '',
                selectedTramite1: null,
            },
            errors: {
                card1: {
                    nombreLink1: [],
                    link: [],
                    selectedTramite1: [],
                },
                card2: {
                    nombreLink1: [],
                    link: [],
                    selectedTramite1: [],
                },
                card3: {
                    nombreLink1: [],
                    link: [],
                    selectedTramite1: [],
                },
                card4: {
                    nombreLink1: [],
                    link: [],
                    selectedTramite1: [],
                },
            },
            items: [
                { id: 1, title: 'card1', link: '', content: this.inputs[0].texturl, order: this.inputs[0].order },
                { id: 2, title: 'card2', link: '', content: this.inputs[1].texturl, order: this.inputs[1].order },
                { id: 3, title: 'card3', link: '', content: this.inputs[2].texturl, order: this.inputs[2].order },
                { id: 4, title: 'card4', link: '', content: this.inputs[3].texturl, order: this.inputs[3].order }
            ],
            formInitialized: false,
            drag: false
        };
    },
    watch: {
        'card1.nombreLink1'(newVal) {
            if (this.formInitialized) {
                 this.updateItem(1, newVal);
            }
        },
        'card2.nombreLink1'(newVal) {
            if (this.formInitialized) {
                this.updateItem(2, newVal);
            }
        },
        'card3.nombreLink1'(newVal) {
            if (this.formInitialized) {
                this.updateItem(3, newVal);
            }
        },
        'card4.nombreLink1'(newVal) {
            if (this.formInitialized) {
                this.updateItem(4, newVal);
            }
        },
        'card1.link'(newVal) {
            if (this.formInitialized) {
                this.updateLink(1, newVal);
            }
        },
        'card2.link'(newVal) {
            if (this.formInitialized) {
                this.updateLink(2, newVal);
            }
        },
        'card3.link'(newVal) {
            if (this.formInitialized) {
                this.updateLink(3, newVal);
            }
        },
        'card4.link'(newVal) {
            if (this.formInitialized) {
                this.updateLink(4, newVal);
            }
        },
        'card1.selectedTramite1'(newVal) {
            if (this.formInitialized) {
                this.updateFicha(1, newVal);
            }
        },
        'card2.selectedTramite1'(newVal) {
            if (this.formInitialized) {
                this.updateFicha(2, newVal);
            }
        },
        'card3.selectedTramite1'(newVal) {
            if (this.formInitialized) {
                this.updateFicha(3, newVal);
            }
        },
        'card4.selectedTramite1'(newVal) {
            if (this.formInitialized) {
                this.updateFicha(4, newVal);
            }
        },
        'card1.showLink'(newVal) {
            if (this.formInitialized) {
                this.updateSwitch(1, newVal);
            }
        },
        'card2.showLink'(newVal) {
            if (this.formInitialized) {
                this.updateSwitch(2, newVal);
            }
        },
        'card3.showLink'(newVal) {
            if (this.formInitialized) {
                this    .updateSwitch(3, newVal);
            }
        },
        'card4.showLink'(newVal) {
            if (this.formInitialized) {
                this.updateSwitch(4, newVal);
            }
        },
    },
    mounted() {
        this.initializeForm();
        this.sortItemsByOrder();
    },
    methods: {
        findOptionByGuid(guid) {
            return this.options.find(option => option.guid === guid) || null;
        },
        initializeForm() {
            // Asegúrate de que options tenga al menos 3 elementos
            setTimeout(() => {
                if (this.options.length >= 4) {
                    this.card1 = {
                        nombreLink1: this.inputs[0].texturl,
                        showLink: this.inputs[0].isFicha === 1,
                        link: this.inputs[0].url,
                        selectedTramite1: this.findOptionByGuid(this.inputs[0].ficha),
                    };
                    this.card2 = {
                        nombreLink1: this.inputs[1].texturl,
                        showLink: this.inputs[1].isFicha === 1,
                        link: this.inputs[1].url,
                        selectedTramite1: this.findOptionByGuid(this.inputs[1].ficha),
                    };
                    this.card3 = {
                        nombreLink1: this.inputs[2].texturl,
                        showLink: this.inputs[2].isFicha === 1,
                        link: this.inputs[2].url,
                        selectedTramite1: this.findOptionByGuid(this.inputs[2].ficha),
                    };
                    this.card4 = {
                        nombreLink1: this.inputs[3].texturl,
                        showLink: this.inputs[3].isFicha === 1,
                        link: this.inputs[3].url,
                        selectedTramite1: this.findOptionByGuid(this.inputs[3].ficha),
                    };
                    this.items[0].order = this.inputs[0].order;
                    this.items[1].order = this.inputs[1].order;
                    this.items[2].order = this.inputs[2].order;
                    this.items[3].order = this.inputs[3].order;
                } else {
                    console.error('Not enough data provided in options');
                }
                this.formInitialized = true;
            }, 1000)
        },
        sortItemsByOrder() {
            this.items.sort((a, b) => a.order - b.order);
        },
        handleSubmit() {
            this.validateForm();
            if (
                this.errors.card1.nombreLink1.length === 0 &&
                this.errors.card1.link.length === 0 &&
                this.errors.card1.selectedTramite1.length === 0 &&
                this.errors.card2.nombreLink1.length === 0 &&
                this.errors.card2.link.length === 0 &&
                this.errors.card2.selectedTramite1.length === 0 &&
                this.errors.card3.nombreLink1.length === 0 &&
                this.errors.card3.link.length === 0 &&
                this.errors.card3.selectedTramite1.length === 0 &&
                this.errors.card4.nombreLink1.length === 0 &&
                this.errors.card4.link.length === 0 &&
                this.errors.card4.selectedTramite1.length === 0
            ) {
                const data = {
                    card1: this.card1,
                    card2: this.card2,
                    card3: this.card3,
                    card4: this.card4,
                    order: this.items,
                };
                axios({
                    url: '/backend/new-home/lo-mas-buscado/edit',
                    method: 'POST',
                    data: data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            }
        },
        validateForm() {
            this.errors.card1 = this.validateCard(this.card1);
            this.errors.card2 = this.validateCard(this.card2);
            this.errors.card3 = this.validateCard(this.card3);
            this.errors.card4 = this.validateCard(this.card4);
        },
        isValidUrl(url) {
            const expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
            const regex = new RegExp(expression);
            return regex.test(url);
        },
        validateCard(card) {
            const errors = {
                nombreLink1: [],
                link: [],
                selectedTramite1: [],
            };
            if (!card.nombreLink1) {
                errors.nombreLink1.push('Este campo es obligatorio');
            }

            if (card.showLink) {
                if (!card.selectedTramite1) {
                    errors.selectedTramite1.push('Seleccione una ficha');
                }
            } else if (!card.showLink) {
                if (!card.link) {
                    errors.link.push('Agregue un link');
                }
                if (!this.isValidUrl(card.link)) {
                    errors.link.push('La URL debe ser válida y comenzar con https://');
                }
            }
            return errors;
        },
        updateItem(cardNumber, newValue) {
            const item = this.items.find(item => item.title === `card${cardNumber}`);
            if (item) {
                item.content = newValue;
            }
        },
        updateLink(cardNumber, newValue) {
            const item = this.items.find(item => item.title === `card${cardNumber}`);
            if (item) {
                item.link = newValue;
            }
        },
        updateFicha(cardNumber, newValue) {
            const item = this.items.find(item => item.title === `card${cardNumber}`);
            if (item) {
                item.link = "fichas/" + newValue.guid;
            }

            // const card = this[`card${cardNumber}`];
            // if (card) {
            //     card.selectedTramite1 = "fichas/" + newValue.guid;
            // }
        },
        updateSwitch(cardNumber, newValue) {
            let item = this.items.find(item => item.title === `card${cardNumber}`);
            let card = this[`card${cardNumber}`]; // Accede al objeto card correspondiente

            if (newValue) {
                if (item) {
                    if (card.selectedTramite1 != null) {
                        item.link = "fichas/" + card.selectedTramite1.guid;
                    }
                }
            } else {
                if (item) {
                    item.link = card.link;
                }
            }
        },
        onOrderChange(event) {
            this.order = this.items.map(item => item.id);
            let orderList = this.order;
            orderList.forEach((value, index) => {
                if(value == 1){
                    this.items[0].order = index;
                }else if(value == 2){
                    this.items[1].order = index;
                }else if(value == 3){
                    this.items[2].order = index;
                }else if(value == 4){
                    this.items[3].order = index;
                }
            })
        }
    }
};
</script>

<style scoped>
    .el-select {
        display: block;
    }
    .ph1 {
        background-color: white;
    }
    .error-message {
        color: red;
    }
    .body-grey{
        background-color: #f6f6f6;
    }
    /*** */
    .card {
        border: 1px solid #e3f1f9;
        padding: 16px;
        transition: border-color 0.3s;
        border-radius: 3px;
        display: flex;
        min-height: 60px;
        text-align: left !important;
        margin-bottom: 10px;
    }

    .card:hover {
        border-color: #296290;
        text-decoration: none !important;
    }

    .card p {
        font-family: 'Roboto Serif', serif;
        font-weight: bold;
        color: #0d4d82;
        width: 400px; /* Ajustado el ancho a 450px */
        text-decoration: underline;
        height: 100%;
        transition: text-decoration 0.3s;
    }

    .card:hover p {
        text-decoration: none;
    }

    .card h5 {
        font-size: 16px;
        line-height: 1.6;
        /* Limitar el ancho del texto */
        max-width: 80%;
        white-space: normal;
        overflow-wrap: break-word; 
        word-wrap: break-word;
        word-break: break-word;
        hyphens: auto;
    }

    .has-gob-title {
        background-image: url("../../images/azul-rojo.svg");
        background-repeat: no-repeat;
        background-size: 92px 10px;
        padding-top: 20px;
        display: block;
        font-size: 33px;
    }

    .has-text-dark {
        color: #363636 !important;
    }

    .has-text-weight-bold {
        font-weight: 700 !important;
    }

    .is-underlined {
        text-decoration: underline;
    }

    .has-font-serif {
        font-family: "Roboto Slab", "Times New Roman", serif !important;
    }

    .has-text-primary {
        color: #0f69b4 !important;
        margin-right: 20px !important;
        font-size: 16px !important;
    }
    h2{
        margin-left: 10px;
        margin-bottom: 15px;
    }

    .badge-alert{
        background-color: #1fa0ff !important;
        /* background-color: orange !important; */
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
